module.exports = __webpack_public_path__ + "img/white.ec76c185.svg";